import React, { useState, useEffect } from 'react';
import './StickyButtons.css';

function StickyButtons() {
  const [isVisible, setIsVisible] = useState(false);
  const [isPhoneExpanded, setIsPhoneExpanded] = useState(false);

  const handlePhoneClick = (e) => {
    // Sur les écrans tactiles, le premier tap ouvre, le deuxième seulement active le lien
    if (window.matchMedia('(pointer: coarse)').matches) {
      if (!isPhoneExpanded) {
        e.preventDefault();
        setIsPhoneExpanded(true);
      } 
      // Si déjà ouvert, le lien tel: est activé normalement
    } else {
      // Sur ordinateur, on prévient le comportement par défaut pour gérer le clic
      e.preventDefault();
      setIsPhoneExpanded(!isPhoneExpanded);
    }
  };

  const toggleVisibility = () => {
    if (window.pageYOffset > 300) {
      setIsVisible(true);
    } else {
      setIsVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisibility);
    return () => {
      window.removeEventListener('scroll', toggleVisibility);
    };
  }, []);

  return (
    <div className="sticky-buttons-container">
      {/* On ajoute le texte du numéro dans une balise span */}
            <a 
        href="tel:+33668150574" 
        className={`sticky-btn phone-btn ${isPhoneExpanded ? 'expanded' : ''}`}
        aria-label="Appeler Couleur Sirène"
        onClick={handlePhoneClick}
        onMouseLeave={() => {
          // Sur ordinateur, si on quitte le bouton et qu'il n'est pas fixé, on le referme
          if (!isPhoneExpanded && !window.matchMedia('(pointer: coarse)').matches) {
            // Rien à faire ici, le CSS gère le :hover
          }
        }}
      >
                <div className="icon-container">
          <svg className={`icon phone-icon ${!isPhoneExpanded ? 'active' : ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z"/></svg>
          <svg className={`icon close-icon ${isPhoneExpanded ? 'active' : ''}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/></svg>
        </div>
        <span className="phone-text">06 68 15 05 74</span>
      </a>

      {isVisible && (
        <button onClick={scrollToTop} className="sticky-btn scroll-top-btn" aria-label="Remonter en haut de la page">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor"><path d="M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z"/></svg>
        </button>
      )}
    </div>
  );
}

export default StickyButtons;